<template>
    <div style="text-align: center">
        <h2>ตั้งเบิกล่วงหน้า</h2>
        <div class="mt-3 row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>รหัสพนักงาน</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <template v-if="!form.id">
                    <multiselect
                            v-model="form.employee"
                            @input="getEmployeeDetails(form.employee)"
                            :options="optionEmployee"
                            select-label=""
                            deselectLabel=""
                            placeholder="เลือกพนักงาน"
                            :customLabel="employeeLabel"
                            track-by="id">
                    </multiselect>
                </template>
                <template v-else>
                    <multiselect
                            v-model="form.employee"
                            @input="getEmployeeDetails(form.employee)"
                            :options="optionEmployee"
                            select-label=""
                            deselectLabel=""
                            :disabled="true"
                            placeholder="เลือกพนักงาน"
                            :customLabel="employeeLabel"
                            track-by="id">
                    </multiselect>
                </template>
            </b-col>
        </div>
        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ชื่อพนักงาน</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <input  v-model="form.employee_name"
                        type="text" class="form-control" disabled/>
            </b-col>
        </div>

        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ยอดเบิก</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <template v-if="!form.id">
                    <input  v-model.number="form.total_advance_payment"
                            type="number" class="form-control" />
                </template>
                <template v-else>
                    <input  v-model.number="form.total_advance_payment"
                            type="number" class="form-control" disabled/>
                </template>
            </b-col>
            <b-col sm="2" class="col-sm-2 text-left">
                <label>บาท</label>
            </b-col>
        </div>

        <h5>การชำระ</h5>

        <div class="mt-3 row form-group">
            <b-col sm="4" class="col-sm-6 text-right">
                <label>รอบการจ่ายเงินที่ต้องการหัก</label>
            </b-col>
            <b-col sm="6"  class=" col-sm-6 row text-left">
                <b-col  class="offset-sm-0 offset-1 col-lg-6  col-12">
                    <input type="radio" id="paid_period_1"
                           v-model="form.paid_period"
                           name="paid_period" value="1">
                    <label for="paid_period_1">&nbsp;วีค 1</label>
                </b-col>
                <b-col  class="offset-sm-0 offset-1 col-lg-6  col-12">
                    <input type="radio" id="paid_period_2"
                           v-model="form.paid_period"
                           name="paid_period" value="2">
                    <label for="paid_period_2">&nbsp;วีค 2</label>
                </b-col>
                <b-col  class="offset-sm-0 offset-1 col-lg-6  col-12">
                    <input type="radio" id="paid_period_3"
                           v-model="form.paid_period"
                           name="paid_period" value="3">
                    <label for="paid_period_3">&nbsp;ทั้งสองวีค</label>
                </b-col>
            </b-col>



        </div>
        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ยอดชำระ</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <input     v-model.number="form.amount_return_per_month"
                        type="number" class="form-control"/>
            </b-col>
            <b-col sm="2" class="col-sm-2 text-left">
                <label>บาท</label>
            </b-col>
        </div>
        <div class="col text-center">
            <button type="button"
                    @click="submitAdvancePayment"
                    class="btn btn-success">
                <icon name="save"></icon>
                บันทึก</button>&nbsp;&nbsp;
            <button type="button"
                   @click="cancelAdvancePayment"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon> ยกเลิก
            </button>
        </div>

        <pre>
            </pre>

<!--        <pre class="alert-success">{{form.id}}</pre>-->
<!--        <pre class="alert-primary">{{form.amount_return_per_month}}</pre>-->
    </div>

</template>

<script>
import {mapState} from "vuex"
import moment from "moment"
import Multiselect from "vue-multiselect"

export default {
        name: "advance-payment-modal",
        props:{
            optionEmployee : { default: Array },
        },
        components:{Multiselect},
        created(){
        },
        data(){
          return{
          }
        },
        computed:{
            ...mapState({
                form: (state) => {
                    return state.AdvancePayment.form;
                },
                user: state => {
                    return state.Auth.user;
                },
            })
        },
        methods:{
            employeeLabel(option){
                return `${option.employee_no} - ${option.name}`
            },
            submitAdvancePayment() {
                if(!this.form.employee){
                    alert('กรุณาเลือกพนักงาน')
                }
                else if(!this.form.total_advance_payment){
                    alert('กรุณากรอกยอดเบิก')
                }
                else if(this.form.total_advance_payment <= 0){
                    alert('กรุณากรอกยอดเบิกให้ถูกต้อง')
                }
                else if(this.form.total_advance_payment < this.form.amount_return_per_month){
                    alert('กรุณากรอกยอดเบิก/ยอดชำระ ให้ถูกต้อง')
                }
                else if(!this.form.amount_return_per_month){
                    alert('กรุณากรอกยอดชำระ')
                }
                else if(this.form.amount_return_per_month <= 0){
                    alert('กรุณากรอกยอดชำระให้ถูกต้อง')
                }
                else{
                    if(this.form.employee){
                        this.form.employee_id = this.form.employee.id;
                        // this.form.paid_period = this.form.employee.salary.paid_period;
                    }
                    else{
                        this.form.employee_id = ""
                    }

                    this.form.date  = moment().format("YYYY-MM-DD");

                    let data ={
                        id: this.form.id,
                        employee_id : this.form.employee_id,
                        advance_payment_status : this.form.paid_period,
                        total_advance_payment : this.form.total_advance_payment,
                        amount_return_per_month : this.form.amount_return_per_month,
                        paid_period : this.form.paid_period,
                        date: this.form.date,
                        recorder: this.user.name,
                    }
                    this.$emit("submit",data)
                }
            },
            cancelAdvancePayment(){
                this.$emit("submit",0)
            },
            getEmployeeDetails(employee){
                if(employee){
                    this.form.employee_name = employee.name;
                    this.form.paid_period = employee.salary.paid_period;
                }
                else{
                    this.form.employee_name = "";
                    this.form.paid_period = "";
                }
            },
        }
    }
</script>

<style scoped>

</style>
